import mainLogo from "../../assets/main-logo.png";

export default function MainLogo() {
  return <img
    src={mainLogo}
    alt="garden"
    id="main-logo"
    className="m-auto p-4" />
}